<template>
  <section class="lib-table">
    <header class="lib-table__head">
      <nav class="lib-table__crumbs">
        <template v-if="allScope && search.trim()">
          <span class="lib-table__crumb is-current">Kết quả tìm trong toàn kho</span>
        </template>
        <template v-else-if="category">
          <template v-for="(node, i) in category.path">
            <i v-if="i" :key="node._id + '-sep'" class="el-icon-arrow-right lib-table__crumb-sep"></i>
            <span
              :key="node._id"
              :class="['lib-table__crumb', { 'is-current': i === category.path.length - 1 }]"
              @click="i < category.path.length - 1 && $emit('open-category', node._id)"
            >{{ node.name }}</span>
          </template>
        </template>
      </nav>
      <span v-if="category && !allScope" class="lib-table__meta">
        {{ category.childCount }} danh mục con · {{ category.itemCount }} bài tập
      </span>
    </header>

    <div class="lib-table__filters">
      <el-input
        v-model="search"
        class="lib-table__search"
        prefix-icon="el-icon-search"
        :placeholder="allScope ? 'Tìm bài tập trong toàn kho' : 'Tìm bài tập trong danh mục này'"
        clearable
      >
        <template #suffix>
          <span
            :class="['lib-table__scope', { 'is-active': allScope }]"
            title="Tìm trong toàn kho"
            @click="allScope = !allScope"
          ><svg class="lib-table__scope-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10" /><path d="M2 12h20" /><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" /></svg> Toàn kho</span>
        </template>
      </el-input>
      <el-select v-model="skill" class="lib-table__select" placeholder="Kỹ năng" clearable>
        <el-option v-for="opt in config.skills" :key="opt._id" :label="opt[`${lang}Value`]" :value="opt._id" />
      </el-select>
      <el-select v-model="subject" class="lib-table__select" placeholder="Bộ môn" clearable>
        <el-option v-for="opt in config.subjects" :key="opt._id" :label="opt[`${lang}Value`]" :value="opt._id" />
      </el-select>
    </div>

    <div class="lib-table__chips">
      <button type="button" :class="['lib-chip', { 'is-active': !kind }]" @click="kind = null">
        Tất cả <span class="lib-chip__count">{{ kindCounts.all || 0 }}</span>
      </button>
      <template v-for="k in KIND_ORDER">
        <button
          v-if="kindCounts[k] || kind === k"
          :key="k"
          type="button"
          :class="['lib-chip', { 'is-active': kind === k }]"
          @click="kind = k"
        >
          <i :class="KIND_META[k].icon" :style="{ color: kind === k ? '#fff' : KIND_META[k].color }"></i>
          {{ KIND_META[k].label }}
          <span class="lib-chip__count">{{ kindCounts[k] || 0 }}</span>
        </button>
      </template>
    </div>

    <div class="lib-table__grid" v-loading="loading && page === 1">
      <div class="lib-row lib-row--head">
        <span>
          <el-checkbox
            :value="allChecked"
            :indeterminate="someChecked && !allChecked"
            :disabled="!assignableItems.length"
            @change="(val) => $emit('toggle-all', assignableItems, val)"
          />
        </span>
        <span>Tên</span>
        <span>Loại</span>
        <span>Kỹ năng</span>
        <span>Nội dung</span>
        <span>Cập nhật</span>
        <span>Thao tác</span>
      </div>

      <div v-for="folder in folders" :key="folder._id" class="lib-row lib-row--folder" @dblclick="$emit('open-category', folder._id)">
        <span></span>
        <span class="lib-row__name">
          <i class="el-icon-folder lib-row__folder-icon"></i>
          <span class="lib-row__title">{{ folder.name }}</span>
        </span>
        <span class="lib-row__muted">Danh mục</span>
        <span></span>
        <span>{{ folder.itemCount }} bài tập</span>
        <span class="lib-row__muted">—</span>
        <span class="lib-row__actions">
          <el-button size="small" plain icon="el-icon-arrow-right" @click="$emit('open-category', folder._id)">Mở</el-button>
        </span>
      </div>

      <div
        v-for="item in list"
        :key="item._id"
        :class="['lib-row', { 'is-selected': !!selected[item._id] }]"
      >
        <span>
          <el-checkbox
            v-if="item.assignable"
            :value="!!selected[item._id]"
            @change="(val) => $emit('toggle', item, val)"
          />
        </span>
        <span class="lib-row__name">
          <span class="lib-kind-icon" :style="{ background: meta(item).bg, color: meta(item).color }">
            <i :class="meta(item).icon"></i>
          </span>
          <span class="lib-row__name-text">
            <span class="lib-row__title" :title="item.title">{{ item.title }}</span>
            <span v-if="allScope && item.categoryPath.length" class="lib-row__path">
              {{ item.categoryPath.map((p) => p.name).join(' › ') }}
            </span>
          </span>
        </span>
        <span>
          <span class="lib-tag" :style="{ background: meta(item).bg, color: meta(item).color }">{{ meta(item).label }}</span>
        </span>
        <span>
          <span v-if="item.skill" class="lib-tag lib-tag--skill">{{ item.skill[`${lang}Value`] }}</span>
          <span v-else class="lib-row__muted">—</span>
        </span>
        <span>{{ item.contentCount }} {{ meta(item).unit }}</span>
        <span class="lib-row__muted">{{ formatDate(item.updatedAt) }}</span>
        <span class="lib-row__actions">
          <el-tooltip content="Xem trước" placement="top">
            <el-button class="lib-icon-btn" size="small" plain icon="el-icon-view" @click="$emit('preview', item)" />
          </el-tooltip>
          <el-button
            v-if="item.assignable"
            class="lib-assign-btn"
            size="small"
            plain
            icon="el-icon-s-promotion"
            @click="$emit('assign', item)"
          >Giao bài</el-button>
          <el-button
            v-else-if="item.kind === 'lesson'"
            class="lib-assign-btn"
            size="small"
            plain
            icon="el-icon-plus"
            @click="$emit('create-lesson', item)"
          >Tạo bài giảng</el-button>
          <el-dropdown v-if="editable" trigger="click" @command="(cmd) => $emit(cmd, item)">
            <el-button class="lib-icon-btn" size="small" plain icon="el-icon-more" />
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="edit" icon="el-icon-edit">Sửa thông tin</el-dropdown-item>
              <el-dropdown-item v-if="item.kind === 'lesson'" command="edit-lesson" icon="el-icon-notebook-2">Sửa bài giảng</el-dropdown-item>
              <el-dropdown-item v-else-if="item.type === 'normal'" command="edit-questions" icon="el-icon-question">Sửa câu hỏi</el-dropdown-item>
              <el-dropdown-item command="delete" icon="el-icon-delete" divided>Xoá</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </span>
      </div>

      <div v-if="!loading && !folders.length && !list.length" class="lib-table__empty">
        {{ search.trim() ? 'Không tìm thấy bài tập phù hợp' : 'Danh mục này chưa có bài tập' }}
      </div>
    </div>

    <footer v-if="total" class="lib-table__foot">
      <span>Đã tải {{ list.length }} / {{ total }} bài tập</span>
      <el-button
        v-if="list.length < total"
        size="small"
        plain
        icon="el-icon-arrow-down"
        :loading="loading && page > 1"
        @click="loadMore"
      >Tải thêm {{ Math.min(limit, total - list.length) }} bài tập</el-button>
    </footer>
  </section>
</template>

<script>
import debounce from 'lodash/debounce'
import examVaultApi from '@/api/exam-vault'
import { KIND_META, KIND_ORDER, cleanParams, formatDate } from './kinds'

const LIMIT = 20

export default {
  name: 'LibraryItemTable',

  props: {
    ownerCategory: { type: String, required: true },
    categoryId: { type: String, default: null },
    editable: { type: Boolean, default: false },
    selected: { type: Object, default: () => ({}) },
    config: { type: Object, required: true }
  },

  data() {
    return {
      KIND_META,
      KIND_ORDER,
      lang: 'vi',
      search: '',
      allScope: false,
      skill: null,
      subject: null,
      kind: null,
      page: 1,
      limit: LIMIT,
      list: [],
      total: 0,
      kindCounts: {},
      category: null,
      folders: [],
      loading: false,
      requestSeq: 0
    }
  },

  computed: {
    assignableItems() {
      return this.list.filter((item) => item.assignable)
    },
    allChecked() {
      return this.assignableItems.length > 0 && this.assignableItems.every((item) => this.selected[item._id])
    },
    someChecked() {
      return this.assignableItems.some((item) => this.selected[item._id])
    },
    // "Toàn kho" chỉ có tác dụng khi đang tìm
    effectiveScope() {
      return this.allScope && this.search.trim() ? 'all' : 'category'
    }
  },

  watch: {
    ownerCategory() {
      this.resetFilters()
    },
    categoryId() {
      if (this.effectiveScope === 'category') this.reload()
    },
    search() {
      this.debouncedReload()
    },
    allScope() {
      if (this.search.trim()) this.reload()
    },
    skill() {
      this.reload()
    },
    subject() {
      this.reload()
    },
    kind() {
      this.reload()
    }
  },

  created() {
    this.lang = this.$i18n.locale
    this.debouncedReload = debounce(this.reload, 300)
    this.reload()
  },

  methods: {
    formatDate,

    meta(item) {
      return KIND_META[item.kind] || KIND_META.exercise
    },

    resetFilters() {
      this.search = ''
      this.allScope = false
      this.skill = null
      this.subject = null
      this.kind = null
      this.$nextTick(this.reload)
    },

    // Mọi thay đổi bộ lọc quay về trang 1 để không lẫn trang cũ
    reload() {
      this.page = 1
      this.fetch()
    },

    loadMore() {
      this.page += 1
      this.fetch()
    },

    async fetch() {
      const scope = this.effectiveScope
      if (scope === 'category' && !this.categoryId) {
        this.list = []
        this.folders = []
        this.total = 0
        this.kindCounts = {}
        this.category = null
        return
      }

      const seq = ++this.requestSeq
      const page = this.page
      this.loading = true
      try {
        const search = this.search.trim()
        const [itemsRes, foldersRes] = await Promise.all([
          examVaultApi.listLibraryItems(
            cleanParams({
              ownerCategory: this.ownerCategory,
              categoryId: scope === 'category' ? this.categoryId : null,
              scope,
              search,
              kind: this.kind,
              skill: this.skill,
              subject: this.subject,
              page,
              limit: this.limit
            })
          ),
          // Dòng danh mục con chỉ hiện khi duyệt danh mục (không tìm/lọc)
          page === 1 && scope === 'category' && !search && !this.kind && !this.skill && !this.subject
            ? examVaultApi.listLibraryCategories({ ownerCategory: this.ownerCategory, parentId: this.categoryId })
            : null
        ])
        if (seq !== this.requestSeq) return

        const data = itemsRes.data
        this.list = page === 1 ? data.list : this.list.concat(data.list)
        this.total = data.pagination.total
        this.kindCounts = data.kindCounts || {}
        if (page === 1) {
          this.category = data.category
          this.folders = foldersRes ? foldersRes.data.list || [] : []
        }
        this.$emit('loaded', data.category)
      } catch (e) {
        if (seq === this.requestSeq && page > 1) this.page = page - 1
        if (seq === this.requestSeq && e?.response?.data?.error?.code === 'E_CATEGORY_NOT_FOUND') {
          this.$emit('category-missing')
        }
      } finally {
        if (seq === this.requestSeq) this.loading = false
      }
    },

    refresh() {
      this.reload()
    }
  }
}
</script>

<style lang="scss" scoped>
$green: #1cab36;

.lib-table {
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding: 18px 0 0;
  background: #fff;
  border: 1px solid #e8ebe9;
  border-radius: 12px;

  &__head,
  &__filters,
  &__chips {
    padding: 0 20px;
  }

  &__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    min-height: 28px;
  }

  &__crumbs {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    font-size: 16px;
  }

  &__crumb {
    color: #6b7280;
    cursor: pointer;

    &.is-current {
      color: #111827;
      font-weight: 700;
      cursor: default;
    }
  }

  &__crumb-sep {
    color: #9ca3af;
    font-size: 12px;
  }

  &__meta {
    color: #6b7280;
    font-size: 13px;
    white-space: nowrap;
  }

  &__filters {
    display: flex;
    gap: 10px;
    margin-top: 14px;
  }

  &__search {
    flex: 1;

    // Căn giữa nút "Toàn kho" (và nút xoá) theo chiều cao ô input
    ::v-deep .el-input__suffix {
      display: flex;
      align-items: center;
      right: 6px;
    }

    ::v-deep .el-input__suffix-inner {
      display: flex;
      align-items: center;
      gap: 4px;
      height: 100%;
    }

    ::v-deep .el-input__inner {
      padding-right: 110px;
    }
  }

  &__scope {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 8px;
    border-radius: 6px;
    background: #f2f4f3;
    color: #6b7280;
    font-size: 12px;
    line-height: 20px;
    cursor: pointer;

    &.is-active {
      background: $green;
      color: #fff;
    }
  }

  &__scope-icon {
    width: 13px;
    height: 13px;
  }

  &__select {
    width: 130px;
  }

  &__chips {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin: 14px 0;
  }

  &__grid {
    min-height: 160px;
  }

  &__empty {
    padding: 40px 0;
    text-align: center;
    color: #9ca3af;
  }

  &__foot {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 16px 20px 20px;
    color: #6b7280;
    font-size: 13px;

    .el-button {
      color: $green;
      font-weight: 600;
    }
  }
}

.lib-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 18px;
  background: #fff;
  color: #374151;
  font-size: 13px;
  cursor: pointer;

  &__count {
    padding: 0 6px;
    border-radius: 9px;
    background: #f2f4f3;
    color: #6b7280;
    font-size: 11px;
    line-height: 18px;
  }

  &.is-active {
    background: $green;
    border-color: $green;
    color: #fff;
    font-weight: 600;

    .lib-chip__count {
      background: rgba(255, 255, 255, 0.25);
      color: #fff;
    }
  }
}

.lib-row {
  display: grid;
  grid-template-columns: 40px minmax(200px, 1fr) 130px 130px 120px 110px 210px;
  align-items: center;
  min-height: 60px;
  padding: 0 20px;
  border-bottom: 1px solid #f0f1f0;
  font-size: 14px;
  color: #111827;

  &--head {
    min-height: 42px;
    background: #f7f8f7;
    color: #4b5563;
    font-weight: 600;
    font-size: 13px;
  }

  &--folder {
    min-height: 52px;
  }

  &.is-selected {
    background: #f1faf3;
  }

  &__name {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
  }

  &__name-text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-width: 0;
    text-align: left;
  }

  &__title {
    max-width: 100%;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__path {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #9ca3af;
    font-size: 12px;
  }

  &__folder-icon {
    color: $green;
    font-size: 18px;
  }

  &__muted {
    color: #6b7280;
  }

  &__actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 6px;
  }
}

.lib-kind-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  font-size: 16px;
}

.lib-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;

  &--skill {
    background: #eef2ff;
    color: #4f46e5;
  }
}

.lib-icon-btn {
  padding: 8px;
}

.lib-assign-btn {
  color: $green;
  border-color: $green;
  font-weight: 600;
}
</style>
